export const toHtml = (text: string): string => {
  let html = text;

  html = html.replace(/```([\s\S]*?)```/g, "<pre><code>$1</code></pre>");

  html = html.replace(/`([^`]+)`/g, "<code>$1</code>");

  html = html.replace(
    /(\|.+\|[\r\n]+\|[-\s|:]+\|[\r\n]+(?:\|.+\|[\r\n]*)*)/g,
    (match) => {
      const lines = match.trim().split(/[\r\n]+/);
      const headerLine = lines[0];
      const bodyLines = lines.slice(2);

      const headerCells = headerLine
        .split("|")
        .map((cell) => cell.trim())
        .filter((cell) => cell);
      const headerRow = `<tr>${headerCells.map((cell) => `<th>${cell}</th>`).join("")}</tr>`;

      const bodyRows = bodyLines
        .map((line) => {
          if (!line.trim()) return "";
          const cells = line
            .split("|")
            .map((cell) => cell.trim())
            .filter((cell) => cell);
          return `<tr>${cells.map((cell) => `<td>${cell}</td>`).join("")}</tr>`;
        })
        .filter((row) => row)
        .join("");

      return `<table><thead>${headerRow}</thead><tbody>${bodyRows}</tbody></table>`;
    }
  );

  html = html.replace(/^###### (.*$)/gim, "<h6>$1</h6>");
  html = html.replace(/^##### (.*$)/gim, "<h5>$1</h5>");
  html = html.replace(/^#### (.*$)/gim, "<h4>$1</h4>");
  html = html.replace(/^### (.*$)/gim, "<h3>$1</h3>");
  html = html.replace(/^## (.*$)/gim, "<h2>$1</h2>");
  html = html.replace(/^# (.*$)/gim, "<h1>$1</h1>");

  html = html.replace(/~~(.*?)~~/g, "<del>$1</del>");

  html = html.replace(/\*\*\*(.*?)\*\*\*/g, "<strong><em>$1</em></strong>");
  html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
  html = html.replace(/\*(.*?)\*/g, "<em>$1</em>");

  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');

  html = html.replace(/!\[(.*?)\]\((.*?)\)/g, '<img alt="$1" src="$2" />');

  html = html.replace(/^> (.*$)/gim, "<blockquote>$1</blockquote>");

  const lines = html.split("\n");
  const processedLines: string[] = [];
  let inOrderedList = false;
  let inUnorderedList = false;

  for (let i = 0; i < lines.length; i += 1) {
    const line = lines[i];
    const isOrderedItem = /^\d+\.\s(.*)/.test(line);
    const isUnorderedItem = /^[-*+]\s(.*)/.test(line);

    if (isOrderedItem) {
      const content = line.replace(/^\d+\.\s(.*)/, "$1");
      if (!inOrderedList) {
        if (inUnorderedList) {
          processedLines.push("</ul>");
          inUnorderedList = false;
        }
        processedLines.push("<ol>");
        inOrderedList = true;
      }
      processedLines.push(`<li>${content}</li>`);
    } else if (isUnorderedItem) {
      const content = line.replace(/^[-*+]\s(.*)/, "$1");
      if (!inUnorderedList) {
        if (inOrderedList) {
          processedLines.push("</ol>");
          inOrderedList = false;
        }
        processedLines.push("<ul>");
        inUnorderedList = true;
      }
      processedLines.push(`<li>${content}</li>`);
    } else {
      if (inOrderedList) {
        processedLines.push("</ol>");
        inOrderedList = false;
      }
      if (inUnorderedList) {
        processedLines.push("</ul>");
        inUnorderedList = false;
      }
      processedLines.push(line);
    }
  }

  if (inOrderedList) processedLines.push("</ol>");
  if (inUnorderedList) processedLines.push("</ul>");

  html = processedLines.join("\n");

  html = html.replace(/\n/g, "<br>");

  html = html.replace(
    /<\/(h[1-6]|ol|ul|li|blockquote|pre|table)><br>/g,
    "</$1>"
  );

  html = html.replace(
    /<br><(h[1-6]|ol|ul|li|blockquote|pre|table)([^>]*>)/g,
    "<$1$2"
  );

  html = html.replace(/<li>([^<]*)<br>/g, "<li>$1");
  html = html.replace(/<br>([^<]*)<\/li>/g, "$1</li>");

  return html;
};
